import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../context/loading";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { fetchAll } from "../../../ApiBaseUrl";
import useBranchAccess from "../../../hooks/useBranchAccess";

function BonusReport() {
  const [loading, setLoading] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();
  const { isBranchAdmin, userBranch } = useBranchAccess();
  const navigate = useNavigate();

  const [reportData, setReportData] = useState({
    month: "",
    year: "",
    category: "",
    type: "",
    branch: "",
    shift: "",

    monthStatus: "unchecked",
    yearStatus: "unchecked",
    categoryStatus: "unchecked",
    typeStatus: "unchecked",
    branchStatus: "unchecked",
    shiftStatus: "unchecked",
  });

  useEffect(() => {
    if (isBranchAdmin && userBranch) {
      setReportData((prev) => ({
        ...prev,
        branch: { value: userBranch, label: userBranch },
        branchStatus: "success",
      }));
    }
  }, [isBranchAdmin, userBranch]);

  const handleReset = () => {
    setReportData({
      month: "",
      year: "",
      category: "",
      type: "",
      branch: "",
      shift: "",
    });
  };

  const [rows, setRows] = useState([]);
  const columns = [
    {
      field: "empid",
      headerName: "Employee ID",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "firstName",
      headerName: "Employee Name",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "branch",
      headerName: "Branch",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "category",
      headerName: "Category",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "employeeType",
      headerName: "Employee Type",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "month",
      headerName: "Month",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "year",
      headerName: "Year",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "bonusType",
      headerName: "Bonus Type",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "employeeCategory",
      headerName: "Employee Category",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "shift",
      headerName: "Shift",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "sumOfBasic",
      headerName: "Sum Of Basic",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "percentage",
      headerName: "Percentage",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "bonusAmount",
      headerName: "Bonus Amount",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
  ];
  const monthOptions = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const yearOptions = [
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" },
    { value: "2027", label: "2027" },
    { value: "2028", label: "2028" },
  ];
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await fetchAll("Category", ["id", "name"]);
        const categories = (data?.allCategory || []).map((c) => ({
          value: c.name,
          label: c.name,
        }));
        setCategoryOptions(categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);
  const typeOptions = [
    { value: "Staff", label: "Staff" },
    { value: "Operator", label: "Operator" },
  ];

  const filterData = async () => {
    setCirleLoading(true);
    try {
      const response = await axios.post(BASEURL, {
        query: `
        query BonusReports($month: Int!, $year: Int!, $category: String, $employeeType: String, $branch: String, $shift: String) { 
        bonusReports(month: $month, year: $year, category: $category, employeeType: $employeeType, branch: $branch, shift: $shift) { 
          employee { 
            id 
            firstName 
            empid 
            category 
            branch 
            employeeType 
          } 
          month 
          year 
          bonusType 
          employeeCategory 
          shift 
          sumOfBasic 
          percentage 
          bonusAmount 
        } 
      } `,
        variables: {
          month: reportData.month?.value || null,
          year: reportData.year?.value || null,
          category: reportData.category?.value || null,
          employeeType: reportData.type?.value || null,
          branch: reportData.branch?.value || null,
          shift: reportData.shift?.value || null,
        },
      });

      const result = response?.data?.data?.bonusReports || [];
      setRows(
        result.map((item, index) => ({
          id: index + 1,
          empid: item.employee.empid,
          firstName: item.employee.firstName,
          branch: item.employee.branch,
          category: item.employee.category,
          employeeType: item.employee.employeeType,
          month: item.month,
          year: item.year,
          bonusType: item.bonusType,
          employeeCategory: item.employeeCategory,
          shift: item.shift,
          sumOfBasic: item.sumOfBasic,
          percentage: item.percentage,
          bonusAmount: item.bonusAmount,
        }))
      );
    } catch (error) {
      console.error("Error in filtering", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (isBranchAdmin && !reportData.branch) return;
    if (reportData.month && reportData.year) {
      filterData();
    } else {
      setRows([]);
    }
  }, [
    reportData.month,
    reportData.year,
    reportData.category,
    reportData.branch,
    reportData.shift,
    reportData.type,
    isBranchAdmin,
  ]);

  const exportToExcel = () => {
    if (!Array.isArray(rows) || rows.length === 0) {
      console.error("No data available for export.");
      return;
    }

    const header = [
      "S.No.",
      "Employee ID",
      "Employee Name",
      "Branch",
      "Category",
      "Employee Type",
      "Month",
      "Year",
      "Bonus Type",
      "Employee Category",
      "Shift",
      "Sum Of Basic",
      "Percentage",
      "Bonus Amount",
    ];

    const data = rows.map((row) => [
      row.id || "",
      row.empid || "",
      row.firstName || "",
      row.branch || "",
      row.category || "",
      row.employeeType || "",
      row.month || "",
      row.year || "",
      row.bonusType || "",
      row.employeeCategory || "",
      row.shift || "",
      row.sumOfBasic || "",
      row.percentage || "",
      row.bonusAmount || "",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bonus Report");

    XLSX.writeFile(workbook, "Bonus_Report.xlsx");
  };

  const handleDropdownChange = (name, selectedOption) => {
    const selectedValue = selectedOption?.value ?? "";

    setReportData((prevreportData) => {
      const updatedState = {
        ...prevreportData,
        [name]: selectedOption,
        [`${name}Status`]: selectedOption ? "success" : "unchecked",
      };
      return updatedState;
    });
  };
  const [branchList, setBranchList] = useState([]);
  const [shiftList, setShiftList] = useState([]);

  useEffect(() => {
    const fetchBranches = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        setBranchList(data?.allBranch);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);
  useEffect(() => {
    onShiftDetails();
  }, []);
  const onShiftDetails = async () => {
    // setCirleLoading(true);
    const query = `
      query allShifts{
allShifts {
  id
  name
  startTime
  endTime
  totalWorkingHours
}
}
      `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const shiftData = response.data?.data?.allShifts; // Adjusted field name
      if (shiftData) {
        setShiftList(shiftData);
      } else {
        console.error("Error: Shift data not found in response.");
      }
      // setCirleLoading(false);
    } catch (error) {
      // setCirleLoading(false);
      console.error("ResponseError:", error);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <IconButton
                  onClick={() => {
                    navigate("/report");
                  }}
                  sx={{ mr: 1, mt: -0.7 }}
                >
                  <ArrowBackIcon />
                </IconButton>{" "}
                <MaterialTypography variant="h5" fontWeight="medium">
                  Bonus Report
                </MaterialTypography>
              </Stack>
              {/* <ButtonGroup>
                      <MaterialButton
                        sx={{ m: 2 }}
                        variant="gradient"
                        color="dark"
                        // onClick={handleReset}
                        >
                        Filter
                      </MaterialButton>
                      <MaterialButton
                        sx={{ m: 2 }}
                        variant="gradient"
                        color="dark"
                        onClick={handleReset}
                        >
                        RESET
                      </MaterialButton>
                    </ButtonGroup> */}
            </Stack>
          }
        />

        <CardContent sx={{ minHeight: "20vh" }}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
            padding={1}
          >
            {/* Start Date */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Month<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="month"
                options={monthOptions}
                value={reportData.month}
                onChange={(selectedOption) =>
                  handleDropdownChange("month", selectedOption)
                }
                success={reportData.monthStatus === "success" ? true : false}
                isClearable
                // name="startDate"
                // type= "date"
                // value={filters.startDate}
                // onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
              />
            </Grid>

            {/* End Date */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Year<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="year"
                options={yearOptions}
                value={reportData.year}
                onChange={(selectedOption) =>
                  handleDropdownChange("year", selectedOption)
                }
                success={reportData.yearStatus === "success" ? true : false}
                isClearable

                // onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                // disabled={!filters.startDate}
              />
            </Grid>

            {/* Category */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Category
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="category"
                options={categoryOptions}
                value={reportData.category}
                onChange={(selectedOption) =>
                  handleDropdownChange("category", selectedOption)
                }
                success={reportData.categoryStatus === "success" ? true : false}
                // value={filters.category}
                isClearable
                // onChange={(e) => setFilters({ ...filters, category: e?.target?.value || e })}
              ></MaterialSelect>
            </Grid>

            {/* Type */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Type
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="type"
                options={typeOptions}
                value={reportData.type}
                onChange={(selectedOption) =>
                  handleDropdownChange("type", selectedOption)
                }
                success={reportData.typeStatus === "success" ? true : false}
                isClearable
                // value={filters.employeeType}
                // onChange={(e) => setFilters({ ...filters, employeeType: e?.target?.value || e })}
              />
            </Grid>

            {/* Branch */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Branch
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="branch"
                options={branchList.map((item) => ({
                  value: item.name,
                  label: item.name,
                }))}
                value={reportData.branch}
                onChange={(selectedOption) =>
                  handleDropdownChange("branch", selectedOption)
                }
                success={reportData.branchStatus === "success" ? true : false}
                isClearable
                isDisabled={isBranchAdmin}
                // value={filters.branch}
                // onChange={(e) => setFilters({ ...filters, branch: e?.target?.value || e })}
              />
            </Grid>

            {/* Shift */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Shift
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="shift"
                options={shiftList.map((item) => ({
                  value: item?.name,
                  label: item?.name,
                }))}
                value={reportData.shift}
                onChange={(selectedOption) =>
                  handleDropdownChange("shift", selectedOption)
                }
                success={reportData.shiftStatus === "success" ? true : false}
                isClearable
                // value={filters.branch}
                // onChange={(e) => setFilters({ ...filters, branch: e?.target?.value || e })}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <MaterialBox
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            flexGrow={1}
          >
            <button
              onClick={exportToExcel}
              style={{
                marginBottom: "10px",
                padding: "8px 12px",
                background: "#4caf50",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Download Excel
            </button>
          </MaterialBox>

          {/* Table */}
          <MaterialDataGrid
            rows={rows || null}
            columns={columns || null}
            loading={loading}
            isSelectable={false}
            // onRowClick={handleRowClick}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Bonus Report found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet added any Bonus Report details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default BonusReport;
